import React from "react";

export default function Up() {
  return (
    <div>
      <h1>Up</h1>
    </div>
  );
}
